

<template>
    <v-container>
    <v-row align="center" justify="center">

    <div>권한 없음 관리자 문의 <br>
    <v-btn color="primary" dark class="mb-2" @click="gotologin()">로그인</v-btn>
    </div>
    </v-row>
    </v-container>

</template>

<script>
import { mapActions } from 'vuex';
import store from '../store';
export default {
    created() {
    },
    computed: {
    },
    methods:{
        gotologin(){
            this.$router.push('/login');
        }        
    }
}
</script>

<style>

</style>
